var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 16.2917C2.875 11.5954 2.875 9.24726 3.78896 7.45352C4.59289 5.8757 5.8757 4.59289 7.45352 3.78896C9.24726 2.875 11.5954 2.875 16.2917 2.875H29.7083C34.4046 2.875 36.7527 2.875 38.5465 3.78896C40.1243 4.59289 41.4071 5.8757 42.211 7.45352C43.125 9.24726 43.125 11.5954 43.125 16.2917V29.7083C43.125 34.4046 43.125 36.7527 42.211 38.5465C41.4071 40.1243 40.1243 41.4071 38.5465 42.211C36.7527 43.125 34.4046 43.125 29.7083 43.125H16.2917C11.5954 43.125 9.24726 43.125 7.45352 42.211C5.8757 41.4071 4.59289 40.1243 3.78896 38.5465C2.875 36.7527 2.875 34.4046 2.875 29.7083V16.2917Z",
    fill: "#7B61FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 12.9375,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4712 23C17.4712 26.0535 19.9465 28.5288 23 28.5288C26.0535 28.5288 28.5288 26.0535 28.5288 23H31.625C31.625 27.7635 27.7635 31.625 23 31.625C18.2365 31.625 14.375 27.7635 14.375 23H17.4712Z",
    fill: "#7B61FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.735bb7eb047e96fe205d36d928db8f31.svg";
export { ForwardRef as ReactComponent };